import axios from "axios"

export default axios.create({
  baseURL: process.env.REACT_APP_MOQ,
  Accept: "application/json",
  "Content-Type": "application/json",
})
